export const pathNames = [{
  title: 'سیگما',
  url: ''
},
{
  title: 'سیگما',
  url: '/'
},
{
  title: 'فراموشی رمز عبور | سیگما',
  url: '/forget-pass'
},
{
  title: 'ورود به سامانه | سیگما',
  url: '/prchs-cntnt?login'
},
{
  title: 'خرید خودرو | سیگما',
  url: '/prchs-cntnt'
},
{
  title: 'فروش خودرو | سیگما',
  url: '/sls-cntnt'
},
{
  title: 'آگهی های فروش | سیگما',
  url: '/purchase-order'
},
{
  title: 'فرم خرید | سیگما',
  url: '/register-purchase-order'
},
{
  title: 'ثبت نام | سیگما',
  url: '/sign-up'
},
{
  title: 'رزرو شوروم | سیگما',
  url: '/purchase-car-reserve'
},
{
  title: 'جزئیات آگهی | سیگما',
  url: '/purchase-car-details'
},
{
  title: 'فرم فروش | سیگما',
  url: '/sell'
},
{
  title: 'فرم ثبت خودرو | سیگما',
  url: '/new-car'
},
{
  title: 'درباره سیگما | سیگما',
  url: '/about-us'
},
{
  title: 'تماس با ما | سیگما',
  url: '/contact-us'
},
{
  title: 'قیمت های روز | سیگما',
  url: '/mana-prices'
},
{
  title: 'کارشناسی در سیگما | سیگما',
  url: '/expert'
},
{
  title: 'تمدید گارانتی در سیگما | سیگما',
  url: '/warranty'
},
{
  title: 'پروفایل کاربری من | سیگما',
  url: '/my-profile'
},
{
  title: 'سفارشات فروش من | سیگما',
  url: '/my-sales-orders'
},
{
  title: 'سفارشات خرید من | سیگما',
  url: '/my-purchase-orders'
},
{
  title: 'رزروهای شوروم من | سیگما',
  url: '/my-reservations'
},
{
  title: 'خودروهای من | سیگما',
  url: '/my-cars'
},
{
  title: 'علاقه مندی های من | سیگما',
  url: '/my-favourites-orders'
},
{
  title: 'افزایش اعتبار | سیگما',
  url: '/raise-credit'
},
{
  title: 'سوالات متداول | سیگما',
  url: '/faq'
},
{
  title: 'حریم خصوصی | سیگما',
  url: '/privacy'
},
{
  title: 'قوانین و مقررات | سیگما',
  url: '/rules'
},
{
  title: 'پرداخت موفق | سیگما',
  url: '/scs-pay'
},
{
  title: 'پرداخت ناموفق | سیگما',
  url: '/err-pay'
},
{
  title: 'فرم ها | سیگما',
  url: '/mana-forms'
},
{
  title: 'تخمین قیمت | سیگما',
  url: '/price-estimate'
},
{
  title: 'معاملات سیگما | سیگما',
  url: '/all-trns'
},
{
  title: 'انتقادات و پیشنهادات | سیگما',
  url: '/sug'
},]